export default {"src":"/_next/static/media/coco-sad.16176e1f.svg","height":144,"width":144,"blurWidth":0,"blurHeight":0};